module.exports = {
    non_contentmenu_show_types: ['tip', 'modify_msg', 'auth_tip', 'operation_tip',
  'shop_common_card', 'call_audio', 'call_video', 'wechat_notice_card'],

    non_multiple_selected_show_types: ['tip', 'modify_msg', 'auth_tip', 'operation_tip',
'shop_common_card', 'call_audio', 'call_video', 'wechat_notice_card'],

    non_forward_show_types: ['tip', 'false_msg', 'modify_msg', 'auth_tip', 'operation_tip',
'shop_common_card', 'provide_contactinfo_card', 'default_contactinfo_card', 'call_audio', 'call_video', 'standard_evaluate_card1', 'standard_evaluate_card2', 'wechat_notice_card'],

  non_delete_show_types: ['tip', 'modify_msg', 'auth_tip', 'operation_tip',
  'shop_common_card', 'call_audio', 'call_video', 'wechat_notice_card'],

  non_collect_show_types:['tip', 'false_msg', 'modify_msg', 'auth_tip', 'operation_tip','universal_card6','provide_contactinfo_card',
  'shop_common_card', 'call_audio', 'call_video', 'standard_evaluate_card1', 'standard_evaluate_card2', 'wechat_notice_card'],  

  non_withdraw_show_types: ['tip', 'modify_msg', 'auth_tip', 'operation_tip',
  'shop_common_card', 'call_audio', 'call_video', 'false_msg', 'standard_evaluate_card1', 'standard_evaluate_card2', 'wechat_notice_card']
};